<table mat-table [dataSource]="dataSource" multiTemplateDataRows class="w-full">
  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <td mat-cell [attr.colspan]="displayedColumns.length" class="border-b-white" *matCellDef="let item">
      {{ getCutoutName(item) }}
    </td>
  </ng-container>

  <!-- X Column -->
  <ng-container matColumnDef="x">
    <th mat-header-cell *matHeaderCellDef i18n>x (мм)</th>
    <td mat-cell *matCellDef="let item">{{ item.x }}</td>
  </ng-container>

  <!-- Y Column -->
  <ng-container matColumnDef="y">
    <th mat-header-cell *matHeaderCellDef i18n>y (мм)</th>
    <td mat-cell *matCellDef="let item">{{ item.y }}</td>
  </ng-container>

  <!-- Height Column -->
  <ng-container matColumnDef="height">
    <th mat-header-cell *matHeaderCellDef i18n>Длина (мм)</th>
    <td mat-cell *matCellDef="let item">{{ item.height }}</td>
  </ng-container>

  <!-- Width Column -->
  <ng-container matColumnDef="width">
    <th mat-header-cell *matHeaderCellDef i18n>Ширина (мм)</th>
    <td mat-cell *matCellDef="let item">{{ item.width }}</td>
  </ng-container>

  <!-- Radius Column -->
  <ng-container matColumnDef="radius">
    <th mat-header-cell *matHeaderCellDef i18n>Радиус сопряжения (мм)</th>
    <td mat-cell *matCellDef="let item">{{ item.radius }}</td>
  </ng-container>

  <!-- Base piont on panel Column -->
  <ng-container matColumnDef="panelBasePoint">
    <th mat-header-cell *matHeaderCellDef i18n>База</th>
    <td mat-cell *matCellDef="let item">
      <csl-base-point-thumbnail [active]="cutoutPoint2Position(item.angle)"></csl-base-point-thumbnail>
    </td>
  </ng-container>

  <!-- Base piont on cutout -->
  <ng-container matColumnDef="cutoutBasePoint">
    <th mat-header-cell *matHeaderCellDef i18n>Точка привязки выреза</th>
    <td mat-cell *matCellDef="let item">
      <ng-container *ngIf="item.basePoint === thisCutoutPoint.Custom; else standardBasePoint"
        >({{ item.fragmentParams.x }};{{ item.fragmentParams.y }})</ng-container
      >
      <ng-template #standardBasePoint>
        <csl-base-point-thumbnail [showAxis]="false" [active]="cutoutPoint2Position(item.basePoint)">
        </csl-base-point-thumbnail>
      </ng-template>
    </td>
  </ng-container>

  <!-- slots column -->
  <ng-container matColumnDef="slots">
    <th class="text-center max-w-26" mat-header-cell *matHeaderCellDef i18n>Пазы</th>
    <td class="max-w-26" mat-cell *matCellDef="let item">
      <span class="text-center text-truncate" [cslOverflowTooltip]="getSlotsDesignation(item)">{{
        getSlotsDesignation(item)
      }}</span>
    </td>
  </ng-container>

  <!-- delete column -->
  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef>
      <button mat-icon-button (click)="openWizard()" [disabled]="!editable" i18n-matTooltip matTooltip="Добавить вырез">
        <mat-icon>add_circle_outline</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let item">
      <button mat-icon-button (click)="deleteCutout(item)" [disabled]="!editable">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: ['name']"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
